import type {
  AdminApiError,
  AdminApiFailure,
  AdminApiMutationResult,
  AdminApiResult,
  AdminApiSuccess,
} from "./types/adminApi";

export function normalizeAdminApiError(
  error:
    | {
        code?: string | null;
        message?: string | null;
        retryable?: boolean;
        details?: Record<string, unknown>;
      }
    | null
    | undefined,
): AdminApiError {
  const normalized: AdminApiError = {
    code: error?.code ?? null,
    message: error?.message ?? "Request failed.",
  };

  if (typeof error?.retryable === "boolean") {
    normalized.retryable = error.retryable;
  }

  if (error?.details) {
    normalized.details = error.details;
  }

  return normalized;
}

export function createAdminApiSuccess<TData>(
  data: TData,
): AdminApiSuccess<TData> {
  return {
    ok: true,
    data,
  };
}

export function createAdminApiFailure(
  error: AdminApiError,
): AdminApiFailure {
  return {
    ok: false,
    error,
  };
}

export function toAdminApiMutationResult(
  result: AdminApiResult<unknown>,
): AdminApiMutationResult {
  if (result.ok) {
    return {
      ok: true,
      error: null,
      code: null,
    };
  }

  return {
    ok: false,
    error: result.error.message,
    code: result.error.code,
    retryable: result.error.retryable,
    details: result.error.details,
  };
}
